module.exports = __webpack_public_path__ + "img/6.2790c08b.png";